import {
    GET_ORDER_INFO,
    ORDER_INFO_INLINE_LOADER,
    CLEAR_RENDER_FROM,
} from '../actionTypes/OrderActionTypes';

export const getOrderInfo = (payload) => ({
    type: GET_ORDER_INFO,
    payload,
});

export const getOrderInfoInlineLoader = (payload) => ({
    type: ORDER_INFO_INLINE_LOADER,
    payload,
});

export const clearRenderFrom = () => ({
    type: CLEAR_RENDER_FROM,
});

export default { getOrderInfo, getOrderInfoInlineLoader, clearRenderFrom };
